import { render } from "./uploadfile2.vue?vue&type=template&id=b34fbf5c&scoped=true"
import script from "./uploadfile2.vue?vue&type=script&lang=js"
export * from "./uploadfile2.vue?vue&type=script&lang=js"

import "./uploadfile2.vue?vue&type=style&index=0&id=b34fbf5c&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b34fbf5c"]])

export default __exports__